import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgNavEntries({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M12.5 2.5h-2.18c0-1.1-.8-2.25-2.32-2.25C6.48.25 5.57 1.4 5.57 2.5H3.5C2.67 2.5 2 3.17 2 4v9.5c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V4c0-.83-.67-1.5-1.5-1.5zM5 12.6a.75.75 0 110-1.5.75.75 0 110 1.5zm0-3a.75.75 0 110-1.5.75.75 0 110 1.5zm0-3a.75.75 0 110-1.5.75.75 0 110 1.5zm6.75 5.55c0 .16-.11.3-.25.3H7c-.14 0-.25-.13-.25-.3v-.6c0-.17.11-.3.25-.3h4.5c.14 0 .25.13.25.3v.6zm0-3c0 .16-.11.3-.25.3H7c-.14 0-.25-.13-.25-.3v-.6c0-.17.11-.3.25-.3h4.5c.14 0 .25.13.25.3v.6zm0-3c0 .17-.11.3-.25.3H7c-.14 0-.25-.13-.25-.3v-.6c0-.17.11-.3.25-.3h4.5c.14 0 .25.13.25.3v.6zM8 1.75a.75.75 0 110 1.5.75.75 0 110-1.5z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgNavEntries.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgNavEntries.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgNavEntries svgRef={ref} {...props} />);
export default ForwardRef;
